export type StepStatus =
  | "error"
  | "complete"
  | "current"
  | "pending"
  | "warning"
  | undefined;

export enum StepsEnum {
  You = 1,
  LoginInfo = 2,
  Mfa = 3,
  Complete = 4,
}
